import React from 'react';
import ReactRating from 'react-rating';
import { SvgIcon } from 'seduo-ui';
const Rating = ({ rating }) => (<div className="rating">
        <ReactRating className="rating__stars" initialRating={rating} emptySymbol={<SvgIcon size={15} kind="StarOutline" className="rating__star"/>} fullSymbol={<SvgIcon size={15} kind="Star" className="rating__star"/>} readonly/>
    </div>);
export default class Example extends React.Component {
    render() {
        return (<section id="ratings" className="rating-summary mb-9 card card-body shadow-uniform">
                <h2 className="card-title text-center mt-7 mb-8">Hodnocení kurzu</h2>
                <div className="mb-5">
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div itemProp="aggregateRating" itemScope={true} itemType="http://schema.org/AggregateRating" className="row text-center">
                                <h1 className="col-12 mb-0 hero-text">
                                    <meta itemProp="ratingValue" content="4.6"/>
                                    92&nbsp;%
                                </h1>

                                <div className="col-12 mb-7 mb-md-0">
                                    <div>
                                        <Rating rating={4}/>
                                    </div>

                                    <span className="text-muted">
                                        <meta itemProp="reviewCount" content="2342"/>2 342 hodnocení
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-10 col-md-6 mx-auto">
                            <div className="row no-gutters align-items-center">
                                <div className="col col-5 col-sm-4 text-right">
                                    <Rating rating={5}/>
                                </div>
                                <div className="col col-3 col-sm-3 mx-6 mx-sm-7">
                                    <div className="progress progress--small">
                                        <div className="progress-bar progress-bar" role="progressbar" aria-valuenow={1666} aria-valuemin={0} aria-valuemax={2342} style={{
                width: '23%',
            }}/>
                                    </div>
                                </div>
                                <div className="col col-auto">
                                    <span className="text-muted">1666x</span>
                                </div>
                            </div>
                            <div className="row no-gutters align-items-center">
                                <div className="col col-5 col-sm-4 text-right">
                                    <Rating rating={4}/>
                                </div>
                                <div className="col col-3 col-sm-3 mx-6 mx-sm-7">
                                    <div className="progress progress--small">
                                        <div className="progress-bar progress-bar" role="progressbar" aria-valuenow={888} aria-valuemin={0} aria-valuemax={2342} style={{
                width: '15%',
            }}/>
                                    </div>
                                </div>
                                <div className="col col-auto">
                                    <span className="text-muted">888x</span>
                                </div>
                            </div>
                            <div className="row no-gutters align-items-center">
                                <div className="col col-5 col-sm-4 text-right">
                                    <Rating rating={3}/>
                                </div>
                                <div className="col col-3 col-sm-3 mx-6 mx-sm-7">
                                    <div className="progress progress--small">
                                        <div className="progress-bar progress-bar" role="progressbar" aria-valuenow={200} aria-valuemin={0} aria-valuemax={2342} style={{
                width: '8%',
            }}/>
                                    </div>
                                </div>
                                <div className="col col-auto">
                                    <span className="text-muted">200x</span>
                                </div>
                            </div>
                            <div className="row no-gutters align-items-center">
                                <div className="col col-5 col-sm-4 text-right">
                                    <Rating rating={2}/>
                                </div>
                                <div className="col col-3 col-sm-3 mx-6 mx-sm-7">
                                    <div className="progress progress--small">
                                        <div className="progress-bar progress-bar" role="progressbar" aria-valuenow={0} aria-valuemin={0} aria-valuemax={2342} style={{
                width: '0%',
            }}/>
                                    </div>
                                </div>
                                <div className="col col-auto">
                                    <span className="text-muted">0x</span>
                                </div>
                            </div>
                            <div className="row no-gutters align-items-center">
                                <div className="col col-5 col-sm-4 text-right">
                                    <Rating rating={1}/>
                                </div>
                                <div className="col col-3 col-sm-3 mx-6 mx-sm-7">
                                    <div className="progress progress--small">
                                        <div className="progress-bar progress-bar" role="progressbar" aria-valuenow={0} aria-valuemin={0} aria-valuemax={2342} style={{
                width: '0%',
            }}/>
                                    </div>
                                </div>
                                <div className="col col-auto">
                                    <span className="text-muted">0x</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <strong className="col-12 col-md-auto">user_25691</strong>
                    <span className="col-6 col-md-auto">
                        <Rating rating={4}/>
                    </span>
                    <span className="col-6 col-md-auto ml-md-auto text-right">
                        <span className="badge badge-outline-alternative">z vaší firmy</span>
                    </span>
                </div>
                <p className="mt-6">
                    Je to kurz na který musím soustředit více pozornosti, ale určitě k zamyšlení. Líbily se mi příklady.
                </p>
                <hr />
                <div className="row">
                    <strong className="col-12 col-md-auto">user_522190</strong>
                    <span className="col-12 col-md-auto">
                        <Rating rating={4}/>
                    </span>
                </div>
                <p className="mt-6">
                    Výborné, děkujeme! Kurz jsem si pouštěl s manželkou a v mnohém jsme se našli. Můj háček je popisný
                    jazyk!
                </p>
                <div className="bg-content px-6 py-5 mb-5">
                    <strong>Reakce lektora:</strong>
                    <p>“Nová reakce“</p>
                </div>

                <div className="no-tap">
                    <hr />
                    <div className="text-center">
                        <a href="#">Dalších 10 recenzí</a>
                    </div>
                </div>
            </section>);
    }
}
